export default {
    tags: [],
    tagCategories: [],
    tagCount: 0,
};
